// src/pages/calculators/PlantRooms.jsx
export default function PlantCalculator() {
  return (
    <>
      <h1>Plant Rooms</h1>
      <p>Indicative areas for HVAC, electrical, and water systems.</p>
    </>
  )
}
